module.exports = __webpack_public_path__ + "img/jb_360.21ed1adf.png";